import { Component, Prop, Vue } from 'vue-property-decorator';
import SingleMainContainer from '../components/shared/singleMainContainer.vue';
import query from '../queries/suggestionsListRequestedChanges';

@Component({ components: { SingleMainContainer } })
export default class SuggestionsListRequestedChanges extends Vue {
  public query = query;
  public get queryVariables() {
    return {
      suggestionsListId: this.$route.params.suggestionsListId,
    };
  }
}
